import { render, staticRenderFns } from "./ProductsTablee.vue?vue&type=template&id=6b46f6a8"
import script from "./ProductsTablee.vue?vue&type=script&lang=js"
export * from "./ProductsTablee.vue?vue&type=script&lang=js"
import style0 from "./ProductsTablee.vue?vue&type=style&index=0&id=6b46f6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports